export const ELLIPSIS = 'ellipsis';

const EDGE_COUNT = 1;
const SIBLING_COUNT = 1;
// First, last, current, a sibling either side and two gaps.
const MAX_ITEMS = EDGE_COUNT * 2 + SIBLING_COUNT * 2 + 3;

// The page numbers to render, collapsing long runs to an ellipsis so the row
// stays a fixed width however many pages there are.
export default function getPageRange(currentPage: number, totalPages: number): (number | typeof ELLIPSIS)[] {
  if (totalPages <= MAX_ITEMS) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const first = 1;
  let start = Math.max(first + EDGE_COUNT, currentPage - SIBLING_COUNT);
  let end = Math.min(totalPages - EDGE_COUNT, currentPage + SIBLING_COUNT);

  // A gap hiding a single page is wider than the page it hides, so absorb that
  // page into the run instead of collapsing it.
  if (start === first + EDGE_COUNT + 1) {
    start -= 1;
  }
  if (end === totalPages - EDGE_COUNT - 1) {
    end += 1;
  }

  const range: (number | typeof ELLIPSIS)[] = [first];

  if (start > first + 1) {
    range.push(ELLIPSIS);
  }

  for (let page = start; page <= end; page += 1) {
    range.push(page);
  }

  if (end < totalPages - 1) {
    range.push(ELLIPSIS);
  }

  range.push(totalPages);

  return range;
}
